<template>
  <div v-bind="$attrs" class="accordion">
    <hr class="my-0" v-if="hasTopBorder"/>
    <div class="accordion__header" @click="toggle()">
      <slot name="header">
      </slot>
      <span class="icon">
        <i class="fas fa-chevron-down">
        </i>
      </span>
    </div>
    <hr class="my-0" v-if="hasDivider"/>
    <div :style="panelStyle">
      <slot name="content">
      </slot>
    </div>
    <slot>
    </slot>
  </div>
</template>

<script>
export default {
  created() {
    this.open = this.value;
  },
  data() {
    return {
      open: false
    }
  },
  props: {
    value: {
      type: Boolean
    },
    accordionClass: {
      default: () => {
        return ['elevation-1']
      },
      type: Array
    },
    hasDivider: {
      default: false,
      type: Boolean
    },
    hasTopBorder: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    panelStyle({ open }) {
      return {
        'max-height': open ? '5000px' : '0px',
        'overflow': 'hidden',
        transition: '0.5s max-height ease-in-out'
      }
    }
  },
  watch: {
    value(v, oldv) {
      if (v != oldv && v != this.open) {
        this.open = v;
      }
    }
  },
  methods: {
    toggle() {
      this.open = !this.open;
      this.$emit('input', this.open)
    }
  }
}
</script>

<style lang="scss" scoped>
.accordion {
  background: #fff;
}

.accordion__header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 12px 24px;
  width: 100%;
  text-align: left;
  border: none;
  outline: none;
  transition: 0.4s ease-in-out;
}

i {
  transition: all 0.3s ease;
}

.rotate {
  transform: rotate(180deg);
}
</style>
